import { OffersState } from 'src/feature-app/redux/reducer';
import { CarlineWithOffers, fetchOffers, Offer } from 'src';
import { fetchCarlineId } from './';
import { OffersFaContent } from 'src/feature-app/';

const removeOffersOfDifferentSalesgroups = (carline: CarlineWithOffers, salesgroup: number) => {
  const newCarline = { ...carline };
  newCarline.ofertas = newCarline.ofertas.filter((oferta) => oferta.carline?.salesgroup?.code === salesgroup);
  return newCarline;
};

export const handleCarlineId = async (
  carlineId: string,
  faContent: OffersFaContent
): Promise<CarlineWithOffers | void> => {
  let carline: CarlineWithOffers;

  if (!faContent && !carlineId) {
    return null;
  }
  if (faContent?.salesgroups?.length > 0) {
    const carlines = await fetchOffers();
    const [salesgroup] = faContent?.salesgroups;

    const carlineWithSelectedSalesgroup = carlines.find((carline) => {
      return carline.ofertas?.find((oferta) => {
        if (oferta.carline?.salesgroup?.code === Number(salesgroup)) {
          return true;
        } else {
          return false;
        }
      });
    });
    if (carlineWithSelectedSalesgroup) {

      return removeOffersOfDifferentSalesgroups(carlineWithSelectedSalesgroup, Number(salesgroup));
    }
  }
  if (faContent?.carlines?.length > 0) {
    carline = await fetchCarlineId(String(faContent.carlines[0]));
  } else {
    carline = await fetchCarlineId(carlineId);
  }

  if (carline) {
    carline.ofertas = carline.ofertas
      .filter((offer: Offer) => offer.prioridad > 0)
      .sort((a: Offer, b: Offer) => {
        return b.prioridad - a.prioridad;
      });

    return carline;
  }
  return null;
};
